import {
  Box,
  Button,
  IconButton,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import {MaterialSymbol} from "react-material-symbols";
import STYLES from "./STYLES";
import {useEffect, useRef} from "react";

interface PromptInputUIProps {
  promptInput: string;
  setPromptInput: (input: string) => void;
  handleSendMessage: (messageInput: string) => void;
  isSending: boolean;
  isPolling: boolean;
  isAutoFocusDisabled: boolean; //true if question type is numerical
}
export default function PromptInputUI({
  promptInput,
  setPromptInput,
  handleSendMessage,
  isSending,
  isPolling,
  isAutoFocusDisabled,
}: PromptInputUIProps) {
  const inputRef = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    if (!isAutoFocusDisabled) {
      inputRef.current?.focus();
    }
  }, [isAutoFocusDisabled]);
  return (
    <Box>
      <Box sx={STYLES.promptInputContainer}>
        <Stack>
          <TextField
            id="chat-bot-send-input"
            variant="outlined"
            size="small"
            placeholder="Ask anything..."
            multiline
            autoFocus={!isAutoFocusDisabled}
            maxRows={10}
            slotProps={{
              input: {
                sx: STYLES.textFieldInput,
              },
            }}
            sx={STYLES.textField}
            fullWidth
            disabled={isSending}
            value={promptInput}
            onChange={e => setPromptInput(e.target.value)}
            onKeyDown={event => {
              if (event.key === "Enter" && !event.shiftKey) {
                event.preventDefault();
                handleSendMessage(promptInput);
              }
            }}
            // Focus input whenever promptInput changes
            inputRef={inputRef}
          />
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between">
            <Stack direction="row" alignItems="center">
              <Tooltip title="More suggestions" arrow placement="top">
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  startIcon={
                    <MaterialSymbol
                      icon="lightbulb"
                      size={16}
                      style={{marginRight: "-4px"}}
                    />
                  }
                  // disabled={isSending || isPolling}
                  sx={STYLES.suggestionsButton}>
                  More suggestions
                </Button>
              </Tooltip>
            </Stack>
            <Tooltip title="Send" arrow placement="top">
              <IconButton
                color="primary"
                disabled={isSending || isPolling}
                sx={STYLES.sendButton}
                onClick={() => handleSendMessage(promptInput)}>
                <MaterialSymbol icon="send" size={16} fill color="white" />
              </IconButton>
            </Tooltip>
          </Stack>
        </Stack>
      </Box>

      <Box height={8} />
      <Box sx={STYLES.disclaimerContainer}>
        <Typography variant="caption" sx={STYLES.disclaimerText}>
          Genie can make mistakes, so double check-it.
        </Typography>
      </Box>
    </Box>
  );
}
